import { TFunction } from 'i18next';

export abstract class Dictionary<T extends Record<string | number, string | number>> {
  private data: Record<T[keyof T], { id: T[keyof T]; title: string }>;
  private t: TFunction;

  constructor(enumObj: T, t: TFunction, translationKey: string) {
    this.t = t;
    this.data = Object.keys(enumObj).reduce((acc, key) => {
      const value = enumObj[key as keyof T];

      if (typeof value === 'number' || typeof value === 'string') {
        acc[value] = { id: value, title: t(`${translationKey}.${key}`) };
      }
      return acc;
    }, {} as Record<T[keyof T], { id: T[keyof T]; title: string }>);
  }

  get(value: T[keyof T]) {
    return this.data[value] || { id: value, title: this.t('unknown') };
  }

  getAll(): { id: T[keyof T]; title: string }[] {
    return Object.values(this.data);
  }
}
